import { createStore } from 'vuex';
import getters from './getters';
import user from './modules/user';
import app from './modules/app';
import task from './modules/task';
import project from './modules/project';

// // https://webpack.js.org/guides/dependency-management/#requirecontext
// const modulesFiles = require.context('./modules', true, /\.js$/)

// // you do not need `import app from './modules/app'`
// // it will auto require all vuex module from modules file
// const modules = modulesFiles.keys().reduce((modules, modulePath) => {
//   // set './app.js' => 'app'
//   const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
//   const value = modulesFiles(modulePath)
//   modules[moduleName] = value.default
//   return modules
// }, {})

const store = createStore({
    modules: {
        user,
        app,
        task,
        project
    },
    getters
});

export default store;
